module.exports = __webpack_public_path__ + "img/banner_back.5c4fb0cb.png";